"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.PurposeAndGuideline = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
function PurposeAndGuideline(_a) {
    var guideline = _a.guideline, purpose = _a.purpose;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "purpose-guideline-container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "purpose-rows-container" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "purpose-guideline-row" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "purpose-guideline-box purpose-guideline-top-row" }, { children: "Purpose for Assessment" })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "purpose-guideline-box purpose-guideline-top-row" }, { children: "Guidelines" }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "purpose-guideline-row" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "purpose-guideline-box" }, { children: purpose })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "purpose-guideline-box" }, { children: guideline }))] }))] })) })));
}
exports.PurposeAndGuideline = PurposeAndGuideline;
//# sourceMappingURL=purpose-guideline.js.map